import {
  createRouter,
  createWebHistory
} from 'vue-router';

export default createRouter({
  history: createWebHistory('/'),
  routes: [
    {
    name: 'main',
    path: '/',
    component: () => import('@/components/SchemesList.vue'),
    },
    {
      name: 'scheme',
      path: '/:id',
      component: () => import('@/components/SchemePage.vue'),
    },
  ],
});
